import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=db981dec&scoped=true&"
import script from "./privacy.vue?vue&type=script&lang=js&"
export * from "./privacy.vue?vue&type=script&lang=js&"
import style0 from "./privacy.vue?vue&type=style&index=0&id=db981dec&lang=scss&scoped=true&"
import style1 from "./privacy.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./privacy.vue?vue&type=style&index=2&id=db981dec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db981dec",
  null
  
)

export default component.exports